// src/pages/GovernmentRFPs.jsx
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import Reveal from '../components/Reveal';

import govImg from '../assets/images/gov-hero.png';

const SERVICES = [
  { title: 'RFP Response Support', desc: 'Technical writing, pricing strategy and compliance documentation support for government procurement responses.' },
  { title: 'Contract Vehicle Support', desc: 'GSA Schedule, SEWP, CIO-SP3 and other contract vehicle positioning and compliance management.' },
  { title: 'Program Management', desc: 'Experienced program managers embedded in government programs to ensure delivery accountability and milestone tracking.' },
  { title: 'Compliance Documentation', desc: 'FISMA, FedRAMP, NIST and agency-specific compliance documentation, reporting and audit preparation.' },
];

const VEHICLES = ['GSA MAS', 'SEWP V', 'CIO-SP3', 'Alliant 2', 'OASIS+', '8(a) STARS III', 'State & Local contracts'];

export default function GovernmentRFPs() {
  return (
    <>
      <SEO
        title="Government & RFPs"
        description="District Sourcing Tech supports government agencies with IT services, workforce staffing, RFP response support and compliance documentation across federal, state and local programs."
        url="https://districtsourcingtech.com/government-rfps"
        keywords="government IT services, RFP support, federal IT staffing, GSA schedule, government procurement, FISMA compliance"
      />
      <Navbar variant="light" />

      {/* Hero */}
      <section className="career-hero">
        <div className="career-hero__bg">
          <img src={govImg} alt="Government and public sector IT" loading="eager" />
        </div>
        <div className="career-hero__overlay" />
        <div className="career-hero__card">
          <p className="career-hero__label">Government &amp; RFPs</p>
          <h1 className="title-1" style={{ marginBottom: '12px', marginTop: '4px' }}>Public sector focus</h1>
          <p className="body-lg" style={{ color: 'var(--token-desc)', marginBottom: '32px' }}>
            DistrictSourcingTech supports government programs requiring continuity documentation and compliance.
          </p>
          <Link to="/contact" className="btn btn-primary">Get in touch</Link>
        </div>
      </section>

      {/* Services grid */}
      <section className="section">
        <div style={{ maxWidth: '1376px', margin: '0 auto' }}>
          <div className="two-col" style={{ marginBottom: '80px' }}>
            <Reveal className="two-col__image">
              <img src={govImg} alt="Government and public sector IT" loading="eager" />
            </Reveal>
            <Reveal delay={150} className="two-col__content">
              <h2 className="title-2" style={{ marginBottom: '16px' }}>Public sector focus</h2>
              <p className="body-lg" style={{ color: 'var(--token-desc)', marginBottom: '24px' }}>
                Government agencies operate under strict compliance, procurement and continuity requirements. Our services are structured to align with these constraints from day one.
              </p>
              <p className="body-lg" style={{ color: 'var(--token-desc)' }}>
                We support agencies from initial procurement through long-term program delivery, with workforce and IT service models built for government operating environments.
              </p>
            </Reveal>
          </div>

          <div className="grid-2-col">
            {SERVICES.map((s, i) => (
              <Reveal
                key={s.title}
                delay={i * 100}
                style={{ background: 'var(--shades-200)', borderRadius: '8px', padding: '40px' }}
              >
                <h3 className="title-5" style={{ marginBottom: '12px' }}>{s.title}</h3>
                <p className="body-lg" style={{ color: 'var(--token-desc)' }}>{s.desc}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* Contract vehicles */}
      <section className="section section--alt">
        <div style={{ maxWidth: '1376px', margin: '0 auto', textAlign: 'center' }}>
          <Reveal>
            <h2 className="title-2" style={{ marginBottom: '16px' }}>Contract vehicles</h2>
            <p className="body-lg" style={{ color: 'var(--token-desc)', marginBottom: '48px', maxWidth: '600px', margin: '0 auto 48px' }}>
              We are positioned or actively pursuing coverage on the following government contract vehicles.
            </p>
          </Reveal>
          <Reveal delay={150}>
            <div className="service-tags" style={{ justifyContent: 'center' }}>
              {VEHICLES.map(v => <span key={v} className="service-tag" style={{ fontSize: '18px', padding: '12px 20px' }}>{v}</span>)}
            </div>
          </Reveal>
        </div>
      </section>

      {/* CTA */}
      <Reveal as="div" className="cta-section">
        <div className="cta-inner" style={{ maxWidth: '1280px', margin: '0 auto' }}>
          <div className="cta-content">
            <h2 className="title-2" style={{ color: '#fff', marginBottom: '8px' }}>Procurement inquiry?</h2>
            <p className="body-lg" style={{ color: 'var(--shades-200)', maxWidth: '432px' }}>
              Reach out to discuss your agency's IT service, staffing or procurement needs.
            </p>
            <Link to="/contact" className="btn btn-light">Contact us</Link>
          </div>
        </div>
      </Reveal>

      <Footer />
    </>
  );
}
